import { createUseStyles } from 'react-jss';

export default createUseStyles({
  questionnaireContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '500px 500px',
    rowGap: '20px',
    marginTop: '30px',
    marginBottom: '30px',
    '& > div:nth-of-type(3)': {
      gridColumn: '1 / 3',
    },
    '@media(max-width: 900px)': {
      display: 'initial',
    },
  },
  questionnaireSelector: {
    width: '50%',
    '@media(max-width: 900px)': {
      width: '100%',
    },
  },
  buttonContainer: {
    paddingTop: '40px',
    paddingBottom: '20px',
    paddingLeft: '20px',
    '@media(max-width: 900px)': {
      paddingTop: 0,
      paddingLeft: 0,
    },
  },
  button: {
    width: '45%',
    '@media(max-width: 900px)': {
      width: '100%',
    },
  },
  downloadTitle: {
    color: '#102131',
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '30px',
  },
  plotWrapperTitle: {
    color: '#102131',
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: 30,
    minHeight: '22px',
    '@media(max-width: 900px)': {
      marginBottom: 20,
      justifyContent: 'center',
    },
  },
});
